function parseCmdAllows(a) {
    const s = (a ?? "").replace(/\s+/g, "");
    const has = (k) => s.includes(k);
    const flags = {
        edit: has("e"),
        insert: has("i"),
        del: has("d"),
        delMark: has("m"),
        rowEdit: has("r"),
        formEdit: has("f"),
        insertGroup: has("g"),
        move: has("x2"),
        copy: has("c"),
        cut: has("t"),
        paste: has("p"),
        hideFilter: has("x3"),
        hideReload: has("x4"),
        hideMaxRows: has("x5"),
        noCopyRow: has("x1"),
    };
    // Нормализация флага edit как общий
    if (!flags.edit && (flags.formEdit || flags.rowEdit))
        flags.edit = true;
    const select = has("s") ||
        flags.edit || flags.rowEdit || flags.insert ||
        flags.delMark || flags.formEdit || flags.del ||
        flags.copy || flags.cut;
    return { ...flags, select };
}

export { parseCmdAllows };
